'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _documentLibrary = require('./documentLibrary');

var _menu = require('./components/menu');

var _overview = require('./overview');

var _detail = require('./detail');

var _products = require('./products');

var _discounts = require('./discounts');

var _news = require('./news');

var _about = require('./about');

var _partnerships = require('./partnerships');

var _partnershipDetail = require('./partnership-detail');

var _contact = require('./contact');

var _contract = require('./contract');

var _contractOverview = require('./contract-overview');

var _sellercategory = require('./sellercategory');

var _public = require('./public');

var _rentProductOverview = require('./rent-product-overview');

var _partnershipGrid = require('./components/partnership-grid');

var _partnershipTile = require('./components/partnership-tile');

var _contactBlock = require('./components/contact-block');

var _heroSlider = require('./components/hero-slider');

var _rentProductDetail = require('./rent-product-detail');

var _sellerTotalPriceDiscounts = require('./components/seller-total-price-discounts');

//import angular from 'angular';
var _module = angular.module('app.seller', []).config(["$stateProvider", "sortProperties", function ($stateProvider, sortProperties) {
    'ngInject';

    $stateProvider.state('seller', {
        url: '/{sellerId:int}',
        parent: 'master',
        views: {
            'menu@root': {
                template: '<site-nav navigation-data="$resolve.navigationData" class="site-nav-compact"></site-nav>'
            },
            'submenu@root': {
                component: 'sellerMenu'
            }
        },
        resolve: {
            navigationData: ["sellerService", "$q", function navigationData(sellerService, $q) {
                var promises = [];
                promises.push(sellerService.getAll());

                return $q.all(promises).then(function (results) {
                    return {
                        sellers: results[0]
                    };
                });
            }],
            numberOfContracts: ["$stateParams", "contractService", "authService", function numberOfContracts($stateParams, contractService, authService) {
                if (authService.isBuyer) {
                    return contractService.getNumberOfContracts($stateParams.sellerId);
                } else {
                    return null;
                }
            }],
            seller: ["$stateParams", "sellerService", function seller($stateParams, sellerService) {
                return sellerService.getById($stateParams.sellerId);
            }],
            sellerModules: ["$stateParams", "sellerService", function sellerModules($stateParams, sellerService) {
                return sellerService.getModules($stateParams.sellerId);
            }],
            parentState: ["$state", function parentState($state) {
                return $state.get('seller');
            }]
        },
        ncyBreadcrumb: {
            label: '{{$resolve.seller.name}}'
        },
        redirectTo: 'seller.home'
    }).state('seller.home', {
        url: '',
        views: {
            'main@root': {
                component: 'seller'
            }
        },
        resolve: {
            rentalProductsCategories: ["$stateParams", "rentalProductsService", function rentalProductsCategories($stateParams, rentalProductsService) {
                return rentalProductsService.getRentalProductCategories($stateParams.sellerId).then(function (result) {
                    return result;
                });
            }]
        },
        ncyBreadcrumb: {
            skip: true
        }
    }).state('sellers', {
        parent: 'general',
        url: '/sellers',
        views: {
            'main@root': {
                component: 'sellerOverview'
            }
        },
        resolve: {
            sellers: ["sellerService", function sellers(sellerService) {
                var data = sellerService.getAll();
                return data;
            }]
        },
        params: {
            breadcrumbName: ''
        },
        ncyBreadcrumb: {
            label: '{{"Sellers" | translate}}'
        }
    }).state('seller.products', {
        url: '/products?page&pageSize&sortProperty&sortAsc&filter',
        views: {
            'main@root': {
                component: 'sellerProducts'
            }
        },
        params: {
            page: {
                value: '1',
                squash: true,
                dynamic: true
            },
            pageSize: {
                squash: true,
                dynamic: true
            },
            sortProperty: {
                value: sortProperties['Name'].value,
                squash: true,
                dynamic: true,
                array: false
            },
            sortAsc: {
                value: (sortProperties['Name'].defaultSorting === 'asc').toString(),
                squash: true,
                dynamic: true,
                array: false
            },
            filter: {
                value: '',
                squash: true,
                dynamic: true
            },
            noReloadFilter: {
                squash: true
            }
        },
        ncyBreadcrumb: {
            label: '{{"Products" | translate}}'
        },
        resolve: {
            // totalPriceDiscounts: function($stateParams, sellerService) {
            //     return sellerService.getSellerTotalPriceDiscounts($stateParams.sellerId);
            // }
        }
    }).state('seller.products.category', {
        url: '/category/{categoryId:int}',
        views: {
            'main@root': {
                component: 'sellerProducts'
            }
        },
        params: {
            page: {
                value: '1',
                squash: true,
                dynamic: true
            },
            pageSize: {
                value: window.localStorage.getItem('pageSize'),
                squash: false,
                dynamic: true
            },
            sortProperty: {
                value: sortProperties['Name'].value,
                squash: true,
                dynamic: true,
                array: false
            },
            sortAsc: {
                value: (sortProperties['Name'].defaultSorting === 'asc').toString(),
                squash: true,
                dynamic: true,
                array: false
            },
            filter: {
                value: '',
                squash: true,
                dynamic: true
            },
            categoryId: {
                squash: true
            }
        },
        reloadOnSearch: true,
        resolve: {
            // category: function($stateParams, categoryService) {
            //     return categoryService.getById($stateParams.categoryId);
            // }
        },
        ncyBreadcrumb: {
            label: '{{$resolve.category.name}}'
        }
    }).state('seller.products.product', {
        url: '/{productId:int}',
        views: {
            'main@root': {
                component: 'product'
            }
        },
        resolve: {
            product: ["$stateParams", "productService", "$state", function product($stateParams, productService, $state) {
                return productService.get($stateParams.productId).then(function (result) {
                    if (result.type === 'RENTAL') {
                        $state.go('seller.rentProductDetail', { sellerId: result.sellerId, productId: result.id }, { reload: true });
                    } else {
                        return result;
                    }
                });
            }]
        },
        reloadOnSearch: false,
        params: {
            // productId: {
            //     value: null,
            //     squash: true
            // },
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{$resolve.product.displayName}}'
        }
    }).state('seller.discounts', {
        url: '/discounts?page&pageSize&sortProperty&sortAsc&filter',
        views: {
            'main@root': {
                component: 'sellerDiscounts'
            }
        },
        reloadOnSearch: false,
        params: {
            page: {
                value: '1',
                squash: true
            },
            pageSize: {
                value: window.localStorage.getItem('pageSize'),
                squash: false
            },
            sortProperty: {
                value: sortProperties['DiscountDate'].value,
                squash: true
            },
            sortAsc: {
                value: (sortProperties['DiscountDate'].defaultSorting === 'asc').toString(),
                squash: true
            },
            filter: {
                value: '',
                squash: true
            }
        },
        ncyBreadcrumb: {
            label: '{{"Discounts" | translate}}'
        },
        onEnter: ["$transition$", "$state", "sellerModules", function onEnter($transition$, $state, sellerModules) {
            if (sellerModules.indexOf('DISCOUNT') >= 0) {
                return true;
            }
            $state.go('seller.home', $transition$.params('to'));
            return false;
        }]
    }).state('seller.partnerships', {
        url: '/partnerships?page',
        views: {
            'main@root': {
                component: 'sellerPartnerships'
            }
        },
        reloadOnSearch: false,
        params: {
            page: {
                value: '1',
                squash: true
            }
        },
        ncyBreadcrumb: {
            label: '{{"Partnerships" | translate}}'
        },
        resolve: {
            partnershipModel: ["$stateParams", "partnershipsService", function partnershipModel($stateParams, partnershipsService) {
                var searchRequest = {
                    skip: 0,
                    take: 50,
                    sellerId: $stateParams.sellerId,
                    title: null
                };
                return partnershipsService.getAll(partnershipsService.init(), searchRequest, 1);
            }]
        },
        onEnter: ["$transition$", "$state", "sellerModules", function onEnter($transition$, $state, sellerModules) {
            if (sellerModules.indexOf('BENEFIT') >= 0) {
                return true;
            }
            $state.go('seller.home', $transition$.params('to'));
            return false;
        }]
    }).state('seller.partnerships.partnership', {
        url: '/{id:int}',
        views: {
            'main@root': {
                component: 'partnershipDetail'
            }
        },
        reloadOnSearch: false,
        params: {},
        ncyBreadcrumb: {
            label: '{{$resolve.partnership.title}}'
        },
        resolve: {
            partnership: ["$stateParams", "partnershipsService", function partnership($stateParams, partnershipsService) {
                return partnershipsService.getById($stateParams.id);
            }]
        }
    }).state('seller.about', {
        url: '/about',
        views: {
            'main@root': {
                component: 'sellerAbout'
            }
        },
        reloadOnSearch: false,
        params: {},
        ncyBreadcrumb: {
            label: '{{"Over" | translate}} {{$resolve.seller.name | translate}}'
        },
        resolve: {
            sellerAbout: ["$stateParams", "sellerService", function sellerAbout($stateParams, sellerService) {
                return sellerService.getSellerAbout($stateParams.sellerId);
            }]
        }
    }).state('seller.contact', {
        url: '/contact',
        views: {
            'main@root': {
                component: 'sellerContact'
            }
        },
        reloadOnSearch: false,
        params: {},
        ncyBreadcrumb: {
            label: '{{"Contact" | translate}}'
        },
        resolve: {
            sellerContact: ["$stateParams", "sellerService", function sellerContact($stateParams, sellerService) {
                return sellerService.getSellerContact($stateParams.sellerId);
            }]
        }
    }).state('seller.contract', {
        url: '/contract',
        onEnter: ["$state", "$stateParams", "sellerService", function onEnter($state, $stateParams, sellerService) {
            sellerService.getSellerContracts($stateParams.sellerId).then(function (result) {
                if (result.length === 1 && result[0].contracts.length === 1) {
                    return $state.go('seller.contractDetail', {
                        id: result[0].contracts[0].id,
                        result: result[0].contracts
                    });
                } else {
                    return $state.go('seller.contractList', {
                        results: result
                    });
                }
            });
        }]
    }).state('seller.contractDetail', {
        url: '/contract/{id:int}',
        views: {
            'main@root': {
                component: 'contractDetail'
            }
        },
        reloadOnSearch: false,
        params: {},
        ncyBreadcrumb: {
            label: '{{$resolve.contract.name}}'
        },
        resolve: {
            contract: ["$stateParams", "sellerService", function contract($stateParams, sellerService) {
                return sellerService.getSellerContract($stateParams.sellerId, $stateParams.id);
            }]
        }
    }).state('seller.contractList', {
        url: '/contract',
        views: {
            'main@root': {
                component: 'sellerContractOverview'
            }
        },
        reloadOnSearch: false,
        params: {},
        ncyBreadcrumb: {
            label: '{{"Contracts" | translate}}'
        },
        resolve: {
            contracts: ["sellerService", "$stateParams", function contracts(sellerService, $stateParams) {
                return sellerService.getSellerContracts($stateParams.sellerId);
            }]
        }
    }).state('seller.public', {
        url: '/public',
        views: {
            'main@root': {
                component: 'sellerPublic'
            },
            'menu@root': {
                template: '<site-nav navigation-data="$resolve.navigationData"></site-nav>'
            },
            'submenu@root': {
                component: undefined
            }
        },
        reloadOnSearch: false,
        params: {},
        ncyBreadcrumb: {
            skip: true
        },
        resolve: {
            sellerPublic: ["$stateParams", "sellerService", function sellerPublic($stateParams, sellerService) {
                return sellerService.getSellerPublic($stateParams.sellerId);
            }]
        }
    }).state('seller.news', {
        url: '/news?page&categoryId&searchValue',
        views: {
            'main@root': {
                component: 'sellerNews'
            }
        },
        resolve: {
            seller: ["$stateParams", "sellerService", function seller($stateParams, sellerService) {
                return sellerService.getById($stateParams.sellerId);
            }]
        },
        reloadOnSearch: false,
        params: {
            page: {
                value: '1',
                squash: true
            },
            categoryId: {
                value: '0',
                squash: true
            },
            searchValue: {
                value: '',
                squash: true
            }
        },
        ncyBreadcrumb: {
            label: '{{"News" | translate}}'
        },
        onEnter: ["$transition$", "$state", "sellerModules", function onEnter($transition$, $state, sellerModules) {
            if (sellerModules.indexOf('NEWS') >= 0) {
                return true;
            }
            $state.go('seller.home', $transition$.params('to'));
            return false;
        }]
    }).state('seller.news.newsitem', {
        url: '/{newsItemId:int}',
        views: {
            'main@root': {
                component: 'news'
            }
        },
        resolve: {
            newsdetail: ["$stateParams", "newsService", function newsdetail($stateParams, newsService) {
                return newsService.getById($stateParams.newsItemId).then(function (newsdetail) {
                    return newsdetail;
                });
            }]
        },
        ncyBreadcrumb: {
            label: '{{$resolve.newsdetail.title | translate}}'
        }
    }).state('seller.doclib', {
        url: '/documentLibrary',
        views: {
            'main@root': {
                component: 'sellerDocumentLibrary'
            }
        },
        resolve: {
            documentCategories: ["$stateParams", "documentLibraryService", function documentCategories($stateParams, documentLibraryService) {
                return documentLibraryService.getLibraryDocumentCategories($stateParams.sellerId).then(function (documentCategories) {
                    return documentCategories;
                });
            }],
            faq: ["$stateParams", "documentLibraryService", function faq($stateParams, documentLibraryService) {
                return documentLibraryService.getLibraryQuestions($stateParams.sellerId).then(function (questions) {
                    return questions;
                });
            }]
        },
        ncyBreadcrumb: {
            label: '{{"Document library"| translate}}'
        }
    }).state('seller.rentProductOverview', {
        url: '/rentAProductOverview?{categoryId:int}',
        views: {
            'main@root': {
                component: 'rentProductOverview'
            }
        },
        resolve: {
            rentalProductsCategories: ["$stateParams", "rentalProductsService", function rentalProductsCategories($stateParams, rentalProductsService) {
                return rentalProductsService.getRentalProductCategories($stateParams.sellerId).then(function (result) {
                    return result;
                });
            }]
        },
        params: {
            categoryId: {
                value: 0,
                squash: true
            }
        },
        ncyBreadcrumb: {
            label: '{{"All Rental products"| translate}}'
        }
    }).state('seller.rentProductDetail', {
        url: '/rentalProduct/{productId:int}',
        views: {
            'main@root': {
                component: 'rentProductDetail'
            }
        },
        resolve: {
            product: ["$stateParams", "rentalProductsService", function product($stateParams, rentalProductsService) {
                return rentalProductsService.getRentalProductById($stateParams.productId).then(function (rentalProduct) {
                    return rentalProduct;
                });
            }]
        },
        ncyBreadcrumb: {
            label: '{{$resolve.product.name}}'
        }
    });
}]).component('sellerDocumentLibrary', _documentLibrary.sellerDocumentLibraryComponent).component('sellerMenu', _menu.sellerMenuComponent).component('sellerOverview', _overview.sellersOverviewComponent).component('seller', _detail.sellerDetailComponent).component('sellerProducts', _products.sellerProductsComponent).component('sellerDiscounts', _discounts.sellerDiscountsComponent).component('sellerNews', _news.sellerNewsComponent).component('sellerAbout', _about.sellerAboutComponent).component('sellerPartnerships', _partnerships.sellerPartnershipsComponent).component('sellerContact', _contact.sellerContactComponent).component('sellerContract', _contract.sellerContractComponent).component('sellerCategory', _sellercategory.sellerCategoryComponent).component('sellerPublic', _public.sellerPublicComponent).component('partnershipDetail', _partnershipDetail.sellerPartnershipDetailComponent).component('partnershipGrid', _partnershipGrid.partnershipGridComponent).component('partnershipTile', _partnershipTile.partnershipTileComponent).component('contactBlock', _contactBlock.contactBlockComponent).component('heroSlider', _heroSlider.heroSliderComponent).component('rentProductOverview', _rentProductOverview.rentProductOverviewComponent).component('sellerTotalPriceDiscounts', _sellerTotalPriceDiscounts.sellerTotalPriceDiscountsComponent).component('sellerContractOverview', _contractOverview.sellerContractOverviewComponent).component('rentProductDetail', _rentProductDetail.rentProductDetailComponent);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./features/seller/index.js
// module id = 1021
// module chunks = 0